'use strict';
/* jshint ignore:start */
var util = require('site/util');

var search = {
	triggerCategoryFilterEvent: function ($filterElement) {
		var obj = {
			'event': 'categoryFilter'
		};

		if ($filterElement.hasClass('reset-filters')) {
			triggerResetFilterEvent();
			return;
		}

		$.extend(obj, getFilterInfo($filterElement));
		dataLayer.push(obj);
	},
	triggerSearchFilterEvent: function ($filterElement) {
		var obj = {
			'event': 'searchFilter'
		};

		if ($filterElement.hasClass('reset-filters')) {
			triggerResetFilterEvent();
			return;
		}

		$.extend(obj, getFilterInfo($filterElement));
		dataLayer.push(obj);
	},
	triggerSearchClearFilters: function () {
		var obj = {
			'event': 'searchClearFilters',
			'category_filter_cocoa': getCocoaFilter(),
			'search_results_returned': $('#shownresults').text(),
			'search_keyword': $('input[name=searchPhrase]').val()
		};
		$.extend(obj, getPageData());
		dataLayer.push(obj);
	},
	initCategorySortEvent: function () {
		$('#grid-sort-header').on('change', function (e) {
			var obj = {
				'event': 'categorySort',
				'button_ID': e.currentTarget.id ? e.currentTarget.id : 'category sort',
				'category_items_number': $('#shownresults').text()
			};
			$.extend(obj, getPageData());
			dataLayer.push(obj);
		});
	},
	initSearchSortEvent: function () {
		$('#grid-sort-header').on('change', function (e) {
			var obj = {
				'event': 'searchSort',
				'button_ID': e.currentTarget.id ? e.currentTarget.id : 'search sort',
				'category_filter_cocoa': getCocoaFilter(),
				'search_results_returned': $('#shownresults').text(),
				'search_keyword': $('input[name=searchPhrase]').val()
			};
			$.extend(obj, getPageData());
			dataLayer.push(obj);
		});
	},
	initCategoryViewEvent: function () {
		$('.toggle-grid i').on('click', function () {
			var obj = {
				'event': 'categoryView',
				'category_items_number': $('#shownresults').text()
			};
			$.extend(obj, getPageData());
			$.extend(obj, getViewClicked($(this)));
			dataLayer.push(obj);
		});
	},
	initSearchViewEvent: function () {
		var obj = {
			'event': 'searchView',
			'category_filter_cocoa': getCocoaFilter(),
			'search_results_returned': $('#shownresults').text(),
			'search_keyword': $('input[name=searchPhrase]').val()
		};
		$.extend(obj, getPageData());
		$.extend(obj, getViewClicked($(this)));
		dataLayer.push(obj);
	},
	initSearchResultsEvent: function () {
		var obj = {
			'event': 'searchResults',
			'category_filter_cocoa': getCocoaFilter(),
			'search_results_returned': $('#shownresults').text(),
			'search_keyword': $('input[name=searchPhrase]').val()
		};
		$.extend(obj, getPageData());
		$.extend(obj, getSearchResultsData());
		dataLayer.push(obj);
	},
	triggerCategoryLoadMore: function () {
		var obj = {
			'event': 'categoryloadMore',
			'category_items_number': $('#shownresults').text()
		};
		$.extend(obj, getPageData());
		dataLayer.push(obj);
	},
	triggerSearchLoadMore: function () {
		var obj = {
			'event': 'searchLoadMore',
			'category_filter_cocoa': getCocoaFilter(),
			'search_results_returned': $('#shownresults').text(),
			'search_keyword': $('input[name=searchPhrase]').val()
		};
		$.extend(obj, getPageData());
		dataLayer.push(obj);
	},
	triggerSearchQuick: function () {
		var obj = {
			'event': 'searchQuick',
			'search_keyword': $('form[name="simpleSearch"]').find(('input[name="q"]')).val(),
			'search_results_returned': $('.product-suggestion').length
		};
		$.extend(obj, getSuggestionData());
		dataLayer.push(obj);
	},
	initAddToCompareEvent: function () {
		$('.compare-check').on('click', function (e) {
			var checked = $('.compare-check:checked');
			if (checked.length > 0 && checked.length < 5) {
				setTimeout(function () {
					var obj = {
					'event': 'addToProductCompare',
					'button_ID': e.currentTarget.id ? e.currentTarget.id : 'add product compare',
					'category_items_number': $('#shownresults').text()
					};
					$.extend(obj, getPageData());
					$.extend(obj, getCompareData(checked));
					dataLayer.push(obj);
				}, 500);
			}
		});
	}
};

/**
 * Takes data available on category or search pages
 *
 * @param buttonID
 * @returns {Object}
 */
function getPageData() {
	var obj = {
		'category_filter_chocolate': getChocolateTypeFilters(),
		'category_filter_diet': getDietaryFilters(),
		'category_filter_price': $('#price-refinement-link').data('minprice') + '-' + $('#price-refinement-link').data('maxprice'),
		'category_filter_product': getProductTypeFilters(),
		'category_name': $('#page_heading').find('h1').text(),
		'category_sort': $('#grid-sort-header').find('option:selected').text(),
		'category_view': getCategoryView()
	};
	return obj;
}

/**
 * Returns string with product type filters delimited by |
 *
 * @returns {String}
 */
function getProductTypeFilters() {
	var productFilters = '';
	if ($('div.productType').find('a.checked').length > 0) {
		$('div.productType').find('a.checked').each(function () {
			if (productFilters !== '') {
				productFilters += '|' + $(this).text().trim();
			} else {
				productFilters += $(this).text().trim();
			}
		});
	}
	return productFilters;
}

/**
 * Returns string with chocolate type filters delimited by |
 *
 * @returns {String}
 */
function getChocolateTypeFilters() {
	var chocolateFilters = '';
	if ($('div.chocolateTypes').find('a.checked').length > 0) {
		$('div.chocolateTypes').find('a.checked').each(function () {
			if (chocolateFilters !== '') {
				chocolateFilters += '|' + $(this).text().trim();
			} else {
				chocolateFilters += $(this).text().trim();
			}
		});
	}
	return chocolateFilters;
}
/**
 * Returns string with dietary filters delimited by |
 *
 * @returns {String}
 */
function getDietaryFilters() {
	var dietaryFilters = '';
	if ($('.dietary').length > 0) {
		var selectedFilters = $('.dietary').find('a.checked');
		if (selectedFilters.length > 0) {
			selectedFilters.each(function () {
				if (dietaryFilters !== '') {
					dietaryFilters += '|' + $(this).text().trim();
				} else {
					dietaryFilters += $(this).text().trim();
				}
			});
		}
	}
	return dietaryFilters;
}

/**
 * Gets values of cocoa percentage filter e.g. 10%-100%
 *
 * @returns {String}
 */
function getCocoaFilter() {
	var cocoaFilter = '';
	if ($('#cocoa-refinement-slider').length > 0) {
		cocoaFilter += $('#cocoa-refinement-slider .noUi-connect .noUi-tooltip').text() + '-' +
					$('#cocoa-refinement-slider .noUi-background .noUi-tooltip').text();
	}
	return cocoaFilter;
}

/**
 * Gets object containing info needed for filtering events
 *
 * @param $filterElement
 * @returns {Object}
 */
 function getFilterInfo($filterElement) {
	var filterCategory = $filterElement.parents('.refinement').find('h3.toggle-refinement').text().trim();
	var filterName = $filterElement.text().split('(')[0].trim();
	var selectState = $filterElement.hasClass('checked') ? 'Selected' : 'Deselected';

	var parametersObj = util.getQueryStringParams(window.location.search.substr(1));

	if ($filterElement.is('#price-refinement-link')) {
		filterName = $('#price-refinement-link').data('minprice') + '-' + $('#price-refinement-link').data('maxprice');
		if (parametersObj.hasOwnProperty('pmax')) {
			selectState = 'Selected';
		}
	}

	if ($filterElement.parent('.refinement').find('#cocoa-refinement-slider').length) {
		filterName = getCocoaFilter();
		if (parametersObj.hasOwnProperty('cmax')) {
			selectState = 'Selected';
		}
	}

	var obj = {
		'filter_category': filterCategory,
		'filter_name': filterName,
		'filter_state': selectState,
		'num_results': $('#shownresults').text()
	};
	return obj;
}

/**
 * Triggers reset filter event
 */
function triggerResetFilterEvent () {
	var obj = {
		'event': 'resetFilters',
		'num_results': $('#shownresults').text()
	};
	dataLayer.push(obj);
}

/**
 * Defines current category view for all events except categoryView
 *
 * @returns {String}
 */
function getCategoryView() {
	var categoryView = 'grid';
	if ($('.toggle-grid').length > 0) {
		var active = $('.toggle-grid').find('i.active');
		if (active.hasClass('list-view') === true) {
			categoryView = 'list';
		}
	}
	return categoryView;
}

/**
 * Defines category view which was clicked for categoryView event
 *
 * @param clicked
 * @returns {Object}
 */
function getViewClicked(clicked) {
	var categoryView = 'grid';
	if (clicked.prop('class') === 'list-view') {
		categoryView = 'list';
	}
	var obj = {
		'category_view': categoryView
	};
	return obj;
}

/**
 * Concatenates product IDs and product Names which are added for comparison
 * Input parameter - checked checkboxes
 *
 * @param checked
 * @returns {Object}
 */
function getCompareData(checked) {
	var productIDs = '';
	var productNames = '';
	checked.each(function () {
		var productTile = $(this).closest('.product-tile');
		// concatenate product IDs
		if (productIDs === '') {
			productIDs += productTile.data('itemid');
		} else {
			productIDs += '|' + productTile.data('itemid');
		}
		// concatenate product names
		if (productNames === '') {
			productNames += productTile.find('.product-name a').attr('title');
		} else {
			productNames += '|' + productTile.find('.product-name a').attr('title');
		}
	});
	var obj = {
		'product_compare_IDs': productIDs,
		'product_compare_names': productNames
	};
	return obj;
}

function getSuggestionData() {
	var interestedIn = '';
	var interestedInCode = '';
	var interestedInImg = '';
	var interestedInPrice = '';
	var interestedInUrl = '';
	var productSuggestion = $('.product-suggestion');
	productSuggestion.each(function () {
		var productDetails = $(this).find('.product-details');
		interestedInImg  += $(this).find('.product-image img').attr('src')  + ' | ';
		interestedIn += productDetails.find('.product-name').text() + ' | ';
		var href = productDetails.find('.product-price a.product-link').attr('href');
		if (href) {
			var beg = href.indexOf('.html');
			var end = href.lastIndexOf('/') + 1;
			var pid = href.substring(end, beg);
			interestedInCode += pid  + ' | ';
		}
		interestedInImg += $(this).find('.product-image img').attr('src')  + ' | ';
		interestedInPrice += productDetails.find('.product-price span.price').text()  + ' | ';
		interestedInUrl += href ? href + ' | ' : '';
	});
	// object to be pushed
	var obj = {
		're_interested_in': interestedIn,
		're_interested_in_code': interestedInCode,
		're_interested_in_img': interestedInImg,
		're_interested_in_price': interestedInPrice,
		're_interested_in_url': interestedInUrl
	};
	return obj;
}

function getSearchResultsData() {
	var interestedIn = '';
	var interestedInCode = '';
	var interestedInImg = '';
	var interestedInPrice = '';
	var interestedInUrl = '';
	var productSuggestion = $('.search-result-items li');
	productSuggestion.each(function () {
		interestedInImg  += $(this).find('.product-image img').attr('src')  + ' | ';
		interestedIn += $(this).find('.product-tile .product-name').text().trim() + ' | ';
		var href = $('.product-tile .product-image .quickview').attr('href');
		var beg = href.indexOf('.html');
		var end = href.lastIndexOf('/') + 1;
		var pid = href.substring(end, beg);
		interestedInCode += pid  + ' | ';
		interestedInImg += $(this).find('.product-image img').attr('src')  + ' | ';
		interestedInPrice += $(this).find('.product-tile .product-pricing span.product-sales-price').text()  + ' | ';
		interestedInUrl += $(this).find('.product-tile a.quickview').attr('href')  + ' | ';
	});
	// object to be pushed
	var obj = {
		're_interested_in': interestedIn,
		're_interested_in_code': interestedInCode,
		're_interested_in_img': interestedInImg,
		're_interested_in_price': interestedInPrice,
		're_interested_in_url': interestedInUrl
	};
	return obj;
}
function getProductImpressionsArray($parent) {
	var impressions = [];
	$parent.find('input[name=productImpression]').each(function (index) {
		var pageLoadData = $(document).find('input[name="pageLoadData"]');
		var pageName = JSON.parse(pageLoadData.val()).page_name;
		var $this = $(this);
		var product = JSON.parse($this.val());
		if (!$this.parent().hasClass('already-seen')) {
			var impression = {
				'impression_position':index + 1,
				'impression_price': product.impression_price,
				'impression_product_SKU':product.impression_product_SKU,
				'impression_product_brand': product.impression_product_brand,
				'impression_product_category': product.impression_product_category,
				'impression_product_name': product.impression_product_name,
				'impression_product_variant': product.impression_product_variant,
				'impression_list': 'PLP - ' + pageName
			};
			impressions.push(impression);
			$this.parent().addClass('already-seen');
		}
	});
	return impressions;
}
module.exports = search;
/* jshint ignore:end */
